import { render } from "./BorderFile.vue?vue&type=template&id=7b06d816&scoped=true"
import script from "./BorderFile.vue?vue&type=script&lang=js"
export * from "./BorderFile.vue?vue&type=script&lang=js"

import "./BorderFile.vue?vue&type=style&index=0&id=7b06d816&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b06d816"

export default script